import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchUserAccountInfo,
} from "../../../../shared/hooks/useFetchAccountInfo";
import API_URLS from "../../Utils/axr";
import store from "../store";

type userInitialStateType = {
    foundData:any;
    loading:any;
};

const initialState: userInitialStateType = {
    foundData:null,
    loading:false
};

export const findAccount : any = createAsyncThunk(
  "finduser/Details",
  async (body: string) => {
    try {
      const reduxStore = store.getState();
      const headers = reduxStore?.brightspeedToken?.headers;
    //   let data="email=lleif9@getnada.com";
      const response = await fetchUserAccountInfo(
        {
          [API_URLS?.accountManagementUrl]: `getUserAccountDetails?refresh-token=${reduxStore?.user?.refreshToken}&`+body,
         },
        headers
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export const forgotUsernameApi : any = createAsyncThunk(
    "forgot/username",
    async (userNameHas: string) => {
      try {
        const reduxStore = store.getState();
        const headers = reduxStore?.brightspeedToken?.headers;
        // let body=`userName=${userNameHas}&${_body}`;
        
        const response = await fetchUserAccountInfo(
          {
            [API_URLS?.accountManagementUrl]: `forgotusername?`+userNameHas,
           },
          headers
        );
        return response.data;
      } catch (error) {
        throw error;
      }
    }
  );

const findSclice = createSlice({
  name: "findusername",
  initialState,
  reducers: {
    setFoundData: (state, action) => {
      state.foundData = action.payload;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(findAccount.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(findAccount.fulfilled, (state,action) => {
        state.loading = false;
        state.foundData = action.payload;
    });

      builder.addCase(forgotUsernameApi.pending, (state) => {
        state.loading = true;
      });
      builder.addCase(forgotUsernameApi.fulfilled, (state,action) => {
          state.loading = false;
      });
    
    }
});

export const {
 setFoundData
} = findSclice.actions;
export default findSclice.reducer;
